import { ThemeProvider as NextThemesProvider } from "next-themes";

/**
 * App-wide theme provider.
 * - Defaults to dark mode (per design spec: "dark mode first").
 * - Persists user preference in localStorage via next-themes.
 * - Uses `class` strategy so Tailwind's `dark:` variants work.
 */
export function ThemeProvider({ children }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem={false}
      storageKey="replyai-theme"
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
